<template>
    <div class="bg-wrap">
        <v-touch v-on:swipeup="swipeUp">
            <div>
                <Head></Head>
            </div>
            <div class="content">
                <p>
                    各位同道，大家好！
                </p>
                <p class="indent">
                    我们诚挚地邀请您参加6月19日由中国心血管健康联盟、苏州工业园区心血管健康研究院主办的“立足经典，联络未来——共筑健康中国心”全国启动会。
                </p>
                <p class="indent">
                    智广博，汇浩瀚。三十年来，我国在心血管疾病防控、治疗、科研和技术应用等方面取得了长足进步，我们见证了中国心血管健康事业的蓬勃发展。
                </p>
                <p class="indent">
                    扬云帆，济沧海。在探索数字化医疗服务转型道路上，面向未来，创建心血管健康服务场域和管理体系，迎接新时代的机遇和挑战。
                </p>
                <p class="indent no">
                    让我们立足经典，联络未来！
                </p>
                <p class="indent no">
                    与您一起，共筑健康中国心！
                </p>
                <p class="indent">
                    期待您的莅临！
                </p>
                <p class="no right">
                    中国心血管健康联盟
                </p>
                <p class="no right">
                    苏州工业园心血管健康研究院
                </p>
                <p class="no right">
                    2022年6月
                </p>
            </div>

            <!--        <div class="toIndex">-->
            <!--            <img @click="toIndex" src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/schedule/arrow.png">-->
            <!--        </div>-->
            <div class="arrow" @click="toIndex">
            </div>

        </v-touch>
    </div>
</template>

<script>

    import Head from "./Head"
    import {isMobile} from "@/assets/util/util";
    import {openId, wxShare} from "@/assets/js/api";
    import wx from "weixin-jsapi";
    // import wx1 from'weixin-js-sdk'
    export default {
        data() {
            return {
                code:this.$route.query.code,
                title: '邀请函 | 立足经典、联络未来',
                desc: "6月19日08:30-12:30\r\n与您一起，共筑健康中国心",
                link: location.href.split("#")[0],
                imgUrl:"https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/icon.jpg",
            }
        },
        components:{
          Head
        },
        created(){
            this.WeChatshare()
        },
        methods:{
            toIndex(){
                this.$router.push("/hz/index")
            },
            swipeUp(){
                this.$router.push("/hz/index")
            },
            async getOpenId(code){
                const res = await openId({code})
                if(res.data.success){
                    this.openId= res.data.openId;
                    localStorage.setItem("openid",this.openId)
                }else{
                    if(isMobile()){//移动端重定向，把code带回来
                        let url = "http://app.iumed.com.cn/hz/welcome"
                        window.location.replace("http://tang.iumed.com.cn?url="+url)
                    }
                }
            },
            async WeChatshare() {
                let _this = this;
                const url = _this.link;
                const res = await wxShare({ url });
                console.log(_this.link, "link");
                console.log(res.data.data, "wxresult");

                if (res.data.success == true) {
                    wx.config({
                        debug: false, //开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: res.data.data.appId, //必填，公众号的唯一标识
                        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
                        signature: res.data.data.signature, // 必填，签名
                        jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 必填，需要使用的JS接口列表
                    });

                    wx.ready(function () {
                        //分享给朋友
                        wx.onMenuShareAppMessage({
                            title: _this.title,
                            desc: _this.desc,
                            link: _this.link,
                            imgUrl: _this.imgUrl,
                            success: function (res) {
                                console.log(res, "分享成功！");
                            },
                            cancel: function (res) {
                                console.log(res, "分享失败");
                            },
                        });
                        //分享到朋友圈
                        wx.onMenuShareTimeline({
                            title: _this.title,
                            link: _this.link,
                            imgUrl: _this.imgUrl,
                            success: function (res) {
                                console.log(res, "分享成功");
                            },
                            cancel: function (res) {
                                console.log(res, "分享失败");
                            },
                        });
                    });
                }
            },
        },
        mounted(){
            // this.$parent.$refs.audio.play();
            let audio = document.getElementById("audio")
            audio.style.display = "none"
            localStorage.setItem("isOff","false")

            let time = document.getElementById("time")
            time.style.display = ""

            this.WeChatshare();

        },
    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/bg-2.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        position: relative;
        /*overflow: scroll;*/
    }
    .content{
        font-size: 12px;
        color: #FFF;
        text-align: left;
        margin: -10px 20px 0 20px;
    }

    .indent{
        text-indent: 20px;
    }

    .no{
        margin: 0;
        padding: 0;
    }
    .right{
        text-align: right;
    }
    .toIndex{
        color: #FFF;
        font-size: 16px;
        margin: 20px;

       img{
           height: 50px;
           transform: rotate(90deg);
       }

        /*animation: anim 1s ease-out infinite;*/
    }
    .arrow{
        position: absolute;
        bottom: 5px;
        right: 48%;
        width: 18px;
        height: 18px;
        border-right: #FFF 3px solid;
        border-top: #FFF 3px solid;
        transform: rotate(-45deg);

        animation: anim 2s ease-out infinite;
    }

    p{
        margin: 0 0 5px 0 ;
        padding: 0;
    }

    @keyframes anim
    {
        0%  { transform: translateY(0px)  rotate(-45deg) ;  opacity: 0;  }
        50% { transform: translateY(-20px)  rotate(-45deg);  opacity: 1;   }
        100% { transform: translateY(0px)  rotate(-45deg); opacity: 0;  }
    }

</style>
